/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Feature_8_DescInputs */

const en_mk_feature_8_desc = /** @type {(inputs: Mk_Feature_8_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explore AI tools, comparisons, coaching, and support for your project needs.`)
};

const id_mk_feature_8_desc = /** @type {(inputs: Mk_Feature_8_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jelajahi katalog alat AI, perbandingan, coaching, dan dukungan untuk kebutuhan proyekmu.`)
};

/**
* | output |
* | --- |
* | "Explore AI tools, comparisons, coaching, and support for your project needs." |
*
* @param {Mk_Feature_8_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_feature_8_desc = /** @type {((inputs?: Mk_Feature_8_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Feature_8_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_feature_8_desc(inputs)
	return en_mk_feature_8_desc(inputs)
});